'use client';

import useInfoModalStore from '@/components/store/infoModalSlice';
import Avatar from '@ui/Avatar';
import Typography from '@ui/Typography';
import getQualifiedImageUrl from '@utils/imageUrlProcessor';
import { formatNumberForLocale } from '@utils/stringHelpers';
import { cx } from 'cva';
import { take } from 'lodash-es';
import Image from 'next/image';
import React from 'react';
import { MdInfo } from 'react-icons/md';

const zIndces = ['z-60', 'z-50', 'z-40', 'z-30', 'z-20', 'z-10'];

function UserRewardsSummary(props) {
  const { badges, totalBadges, avatar, name, points, level } = props;
  const nekies = formatNumberForLocale(points);
  const badgesToRender = take(badges, 3);

  const setShowInfoModal = useInfoModalStore((state) => state.setOpen);

  const handleShowInfo = () => {
    setShowInfoModal(true, {
      logoUrl: '/assets/images/neki-heart.png',
      title: 'Neki Score',
      name: 'Neki Score',
      description:
        'Your Neki Score represents your individual journey of creating goodness — every act of giving, volunteering, and engagement increases both your personal impact and your community’s collective Neki Score.',
    });
  };

  return (
    <div className="flex w-full flex-col items-start justify-start gap-4">
      {/* Avatar and Name */}
      <div className="flex items-center gap-2">
        <Avatar src={getQualifiedImageUrl(avatar)} alt={name} size="sm" />
        <Typography variant="h3">{name}</Typography>
      </div>

      {/* Nekies Row */}
      <div className="ml-5 flex w-full items-center gap-2">
        <Image
          // src="/assets/images/neki-heart.png"
          src="/assets/icons/nekies.svg"
          width={28}
          height={28}
          alt="neki-score"
          className="h-7 w-7 object-contain"
        />
        <div className="flex w-full items-center gap-2">
          <Typography variant="button" className="text-center">
            {/* Neki Score: {nekies} */}
            {nekies} Nekies
          </Typography>
          {/* <div
            className="flex cursor-pointer items-center justify-center"
            onClick={handleShowInfo}>
            <MdInfo className="h-5 w-5 text-text-disabled" />
          </div> */}
        </div>
      </div>

      {/* Badges Row */}
      <div className="ml-5 flex w-full flex-col items-start gap-2">
        {totalBadges > 0 && (
          <div className="flex items-center gap-2">
            <div className="flex items-center -space-x-2">
              {badgesToRender.map(({ badge }, index) => (
                <div
                  key={badge.id}
                  className={cx('relative inline', zIndces[index])}>
                  <Image
                    src={getQualifiedImageUrl(badge.imageUrl) || ''}
                    alt={badge.name}
                    width={28}
                    height={28}
                    className="h-7 w-7 object-contain"
                  />
                </div>
              ))}
              {totalBadges > badgesToRender.length && (
                <div className="relative z-70 inline h-6 w-6">
                  <div className="flex items-center justify-center rounded-full bg-white p-1">
                    <Typography variant="caption" color="secondary">
                      +{totalBadges - badgesToRender.length}
                    </Typography>
                  </div>
                </div>
              )}
            </div>
            <Typography variant="button">Badges</Typography>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserRewardsSummary;
